module.exports = __webpack_public_path__ + "static/img/newsdynamic.ede56b5e.png";